import { getTenantFromSubdomain } from "fe-shared/src/helpers/tenantUtils";

type ApplicationConfig = {
  [key: string]: string;
};

interface WindowWithAppConfig extends Window {
  APP_CONFIG?: ApplicationConfig;
}

const { APP_CONFIG = {} } = window as WindowWithAppConfig;

// For dev / test / prod those values should come from environment variables helm-library project
const DEFAULT_CONFIG: ApplicationConfig = {
  APIGATEWAY_HOST: "https://portal-appgateway.devmt.{tenant}.esrpapplication.com/",
  IDENTITY_HOST_URL: `https://ids.devmt.esrpapplication.com/`,
  APPLICATIONS_HOST_URL: "https://localhost:3002/",
  TRANSACTIONS_HOST_URL: "https://localhost:3001/",
  REQUESTS_HOST_URL: "https://localhost:3003/",
  ADMIN_HOST_URL: "https://localhost:3004/",
  REMITTANCES_HOST_URL: "https://localhost:3005/",
  EXTERNAL_CONTAINER_HOST_URL: "https://webapp.devmt.{tenant}.esrpapplication.com/",
  HELP_PORTAL_URL: `https://portal-help.devmt.esrpapplication.com/`,
  ENV: "devmt",
  SENTRY_VERSION: "36.0",
};


/**
 * Gets dynamic API host URL with tenant identifier
 * @param tenantId - optional tenant ID (if not provided, extracted from URL)
 * @returns API host URL with tenant
 */
export const getApiHostUrl = (tenantId?: string): string => {
  const tenant = tenantId || getTenantFromSubdomain();

  if (!tenant) {
    if (process.env.NODE_ENV === 'production') {
      throw new Error('Unable to determine tenant identifier for API host URL');
    }
    // FOR LOCALHOST TESTING ONLY
    return DEFAULT_CONFIG.APIGATEWAY_HOST.replace('{tenant}', 'rnb');
  }
  
  const apiHost = APP_CONFIG.APIGATEWAY_HOST || DEFAULT_CONFIG.APIGATEWAY_HOST;
  
  return apiHost.replace('{tenant}', tenant);
};

/**
 * Gets dynamic external app URL with tenant identifier
 * @param tenantId - optional tenant ID (if not provided, extracted from URL)
 * @returns external app URL with tenant
 */
export const getExternalAppUrl = (tenantId?: string): string => {
  const tenant = tenantId || getTenantFromSubdomain();

  if (!tenant) {
    throw new Error('Unable to determine tenant identifier for external app URL');
  }

  const externalAppUrl = APP_CONFIG.EXTERNAL_CONTAINER_HOST_URL || DEFAULT_CONFIG.EXTERNAL_CONTAINER_HOST_URL;
  
  return externalAppUrl.replace('{tenant}', tenant);
};

export default {
  ...DEFAULT_CONFIG,
  ...APP_CONFIG,
};
